export default function authHeader() {
  const tokenStr = localStorage.getItem('AccessToken');
  if (tokenStr && tokenStr !== 'undefined' && tokenStr !== 'null') {
    try {
      const token = JSON.parse(tokenStr);
      if (token) {
        return { Authorization: 'Bearer ' + token };
      }
    } catch (e) {
      console.error("Error parsing AccessToken in authHeader:", e);
    }
  }
  return {};
}